import { render, staticRenderFns } from "./AddOpenWarnCom.vue?vue&type=template&id=1221a294&scoped=true"
import script from "./AddOpenWarnCom.vue?vue&type=script&lang=js"
export * from "./AddOpenWarnCom.vue?vue&type=script&lang=js"
import style0 from "./AddOpenWarnCom.vue?vue&type=style&index=0&id=1221a294&prod&scoped=true&lang=css"
import style1 from "./AddOpenWarnCom.vue?vue&type=style&index=1&id=1221a294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221a294",
  null
  
)

export default component.exports